import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=386b3b5c&scoped=true"
import script from "./HistoryTable.vue?vue&type=script&lang=js"
export * from "./HistoryTable.vue?vue&type=script&lang=js"
import style0 from "./HistoryTable.vue?vue&type=style&index=0&id=386b3b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3b5c",
  null
  
)

export default component.exports